import { ReactNode } from "react";

import PageWrapper from "components/PageWrapper";
import PageInfoHeader from "ds/components/PageInfoHeader";
import Box from "ds/components/Box";

type AccountDeletionPageLayoutProps = {
  children: ReactNode;
};

const AccountDeletionPageLayout = ({ children }: AccountDeletionPageLayoutProps) => {
  return (
    <>
      <PageInfoHeader title="Account deletion" />
      <PageWrapper>
        <Box direction="column" limitWidth="medium" gap="x-large" fullWidth>
          {children}
        </Box>
      </PageWrapper>
    </>
  );
};

export default AccountDeletionPageLayout;
